import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import {getVersion, verifySessionAccount} from "@/services/api";
import i18n from "@/i18n";

const Login = () => import('@/views/Login.vue');
const Guide = () => import("@/views/Guide.vue");
const Home = () => import("@/views/Home.vue");
const UserGrouping = () => import("@/views/UserGrouping.vue");
const UserGroupingSetting = () => import("@/views/UserGroupingSetting.vue");
const UserGroupingUpload = () => import("@/views/UserGroupingUpload.vue");
const UserManagement = () => import("@/views/UserManagement.vue");
const AccountSettings = () => import("@/views/AccountSettings.vue");
const DataAccess = () => import("@/views/DataAccess.vue");
const StrategyFlow = () => import("@/views/process/StrategyFlow.vue");
const EmailVerify = () => import("@/views/EmailVerify.vue");
const Unsubscribe = () => import("@/views/Unsubscribe.vue");
const Subscribe = () => import("@/views/Subscribe.vue");
const SubscriptionPlan = () => import("@/views/SubscriptionPlan.vue");
const Index = () => import("@/views/Index.vue");
const Router = () => import("@/views/Router.vue");
const Error403 = () => import("@/views/Error403.vue");

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'router.text_767b5f55'
    },
  },
  {
    path: "/",
    redirect: "/home",
    component: Index,
    name: "index",
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          title: 'router.text_99969875'
        },
      },
      {
        //营销活动
        path: '/marketing/campaign/',
        redirect: "/cartsee-new/campaign/list",
        name: 'MarketingCampaign',
        component: Router,
        children:[
          {
            path: 'detailed/:id',
            name: 'MarketingCampaignDetailed',
            component: () => import('@/views/campaign/detailed/index.vue'),
            meta: {
              title: 'router.text_6d3b52a8660e7ec6'
            },
          },

        ]
      },
      {
        //营销流程
        path: '/marketing/process/',
        redirect: "/cartsee-new/flow/list",
        name: 'MarketingProcess',
        component: Router,
        children:[
          {
            path: 'list',
            name: 'MarketingProcessList',
            component: () => import("@/views/process/List.vue"),
            meta: {
              title: 'router.text_842595006d417a0b'
            },
          },
          {
            path: 'detailed/:id',
            name: 'MarketingProcessDetailed',
            component: () => import('@/views/process/detailed/index.vue'),
            meta: {
              title: 'router.text_7b5675655668660e'
            },
          },
        ]
      },
      {
        path: '/marketing/process/v2/detailed/:id',
        name: '',
        component: () => import('@/views/process/detailedV2/index.vue'),
      },
      {
        //订阅工具
        path: '/wheel_of_fortune/',
        name: 'wheelOfFortune',
        component: Router,
        children:[
          {
            path: 'list',
            name: 'wheelOfFortuneList',
            component: () => import("@/views/wheelOfFortune/List.vue"),
            meta: {
              title: 'router.popups.home'
            },
          },
          // abtest
          {
            path: 'abtest',
            name: 'wheelOfFortuneABTest',
            component:() => import("@/views/wheelOfFortune/abtest/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          {
            path: 'abtest/:id',
            name: 'wheelOfFortuneABTest',
            component:() => import("@/views/wheelOfFortune/abtest/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          //大转盘
          {
            path: 'setting',
            name: 'wheelOfFortuneSettingNew',
            component: () => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          {
            path: 'setting/:id',
            name: 'wheelOfFortuneSetting',
            component:() => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          {
            path: 'setting/copy/:copyId',
            name: 'wheelOfFortuneSetting',
            component:() => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          {
            path: 'check/:id',
            name: 'wheelOfFortuneCheck',
            component: () => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: 'router.popups.view'
            },
          },
          //弹窗
          {
            path: 'pop',
            name: 'wheelOfFortunePopNew',
            component: () => import("@/views/wheelOfFortune/pop/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          {
            path: 'pop/:id',
            name: 'wheelOfFortunePop',
            component: () => import("@/views/wheelOfFortune/pop/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
          {
            path: 'pop/copy/:copyId',
            name: 'wheelOfFortunePop',
            component: () => import("@/views/wheelOfFortune/pop/index.vue"),
            meta: {
              title: 'router.text_8ba296055de55177'
            },
          },
        ]
      },
      {
        //用户群
        path: '/user/',
        name: 'user',
        component: Router,
        children:[
          {
            path: 'grouping',
            name: 'UserGrouping',
            component: UserGrouping,
            meta: {
              title: 'router.text_752862377fa4'
            },
          },
          {
            path: 'grouping/setting',
            name: 'UserGroupingSetting',
            component: UserGroupingSetting,
            meta: {
              title: 'router.text_752862377fa47f16'
            },
          },
          {
            path: 'grouping/setting/:id',
            name: 'UserGroupingSettingId',
            component: UserGroupingSetting,
            meta: {
              title: 'router.text_752862377fa47f16'
            },
          },
          {
            path: 'grouping/upload',
            name: 'UserGroupingUpload',
            component: UserGroupingUpload,
            meta: {
              title: 'router.text_752862377fa44e0a'
            },
          },
          {
            path: 'grouping/upload/:id',
            name: 'UserGroupingUploadId',
            component: UserGroupingUpload,
            meta: {
              title: 'router.text_752862377fa44e0a'
            },
          },

        ]
      },
      {
        path: '/data/access',
        name: 'DataAccess',
        redirect: '/cartsee-new/data/access',
        component: DataAccess,
        meta: {
          title: 'router.text_6570636e63a55165'
        },
      },
      {
        path: '/user/management',
        name: 'UserManagement',
        component: UserManagement,
        meta: {
          title: 'router.text_752862377ba17406'
        },
      },
      {
        path: '/subscription/plan',
        name: 'SubscriptionPlan',
        component: SubscriptionPlan,
        meta: {
          title: 'router.text_8ba2960559579910'
        },
      },
        {
          path: '/403',
          name: 'Error403',
          component: Error403,
          meta: {
            title: '403 | CartSee'
          },
        },

    ]
  },
  {
    path: '/guide',
    name: 'Guide',
    component: Guide,
    meta: {
      title: 'router.text_65b0624b5f155bfc'
    },
  },
  {
    //在react中
    path: '/account/settings',
    name: 'AccountSettings',
    component: AccountSettings,
    meta: {
      title: 'router.text_8d2653f78bbe7f6e'
    },
  },

  {
    path: '/strategy/flow',
    name: 'StrategyFlow',
    redirect: '/cartsee-new/strategy/flow/:id',
    component: StrategyFlow,
    meta: {
      title: 'router.text_6d417a0b7f168f91'
    },
  },
  {
    path: '/strategy/flow/:id',
    name: 'StrategyFlowId',
    redirect: '/cartsee-new/strategy/flow/:id',
    component: StrategyFlow,
    meta: {
      title: 'router.text_6d417a0b7f168f91'
    },
  },
  {
    path: '/strategy/copy/:copyId',
    name: 'StrategyFlowCopyId',
    redirect: '/cartsee-new/strategy/copy/:copyId',
    component: StrategyFlow,
    meta: {
      title: 'router.text_6d417a0b7f168f91'
    },
  },
  {
    path: '/strategy/check/:id',
    name: 'StrategyCheckId',
    redirect: '/cartsee-new/strategy/flow/:id',
    component: StrategyFlow,
    meta: {
      title: 'router.text_6d417a0b67e5770b'
    },
  },
  {
    path: '/email/verify',
    name: 'EmailVerify',
    component: EmailVerify,
    meta: {
      title: 'router.text_90ae4ef69a8c8bc1'
    },
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe,
    meta: {
      title: 'Unsubscribe'
    },
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: Subscribe,
    meta: {
      title: 'Subscribe'
    },
  },
  {
    path: '/resubscribe',
    name: 'Resubscribe',
    component: Subscribe,
    meta: {
      title: 'Resubscribe'
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

});

let appVersion = '';
router.beforeEach((to, from, next) => {
  verifySessionAccount();
  // 跳转arco项目
  if(to.path.startsWith('/cartsee-new')) {
    console.log('[nav] intercept cartsee-new →', to.path, 'VUE_APP_DOMAIN=', process.env.VUE_APP_DOMAIN);
    let target = (process.env.VUE_APP_DOMAIN || '') + to.path;
    // 跨系统传递当前语言
    try {
      const lang = i18n.locale || 'zh-CN';
      target += (target.includes('?') ? '&' : '?') + 'lang=' + encodeURIComponent(lang);
    } catch { /* ignore */ }
    // DEV ONLY: 本地跨端口时带上 localStorage 以便目标侧 hydrate（生产 no-op）
    try {
      if (
        typeof process.env.VUE_APP_DOMAIN === 'string' &&
        process.env.VUE_APP_DOMAIN.startsWith('http://localhost') &&
        window.location.hostname === 'localhost'
      ) {
        const payload: Record<string, string> = {};
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k) payload[k] = localStorage.getItem(k) || '';
        }
        const encoded = btoa(encodeURIComponent(JSON.stringify(payload)));
        target += '#__devsync=' + encoded;
      }
    } catch { /* ignore */ }
    window.location.replace(target);
    return; // 外部跳转后不再执行 next()，避免渲染空白路由
  }
  // if (to.matched.length === 0) {
  //   next( {
  //     path: '/error',
  //     query: to.query
  //   })
  //   // 储存错误的路由地址，方便以后使用
  //   sessionStorage.errorUri = to.fullPath;
  //   return;
  // }
  // getVersion().then(res => {
  //   try {
  //     const newVersion = res.data.version;
  //     if (appVersion && appVersion !== newVersion) {
  //       location.reload();
  //     } else {
  //       appVersion = newVersion;
  //     }
  //   } catch (e) {}
  // })

  /* 路由切换时，如果没有就添加，有就跳过执行，添加固定参数 */
  let query = to.query;
  let queryCtrl = false;
  if (from.query.state && !to.query.state) {
    query.state = from.query.state;
    queryCtrl = true;
  }
  if (queryCtrl) {
    next({
      path: to.path,
      query: query
    });
  } else {
    next();
  }

  /* 设置title —— meta.title 存 i18n key 或字面量，vue-i18n 缺 key 时返回 key 自身，正好兼容字面量 */
  const metaTitle = to.meta?.title as string | undefined;
  if (metaTitle) {
    const translated = i18n.t(metaTitle) as string;
    // 翻译为空（极端情况）时用 metaTitle 原值兜底；metaTitle 也为空才退到 'CartSee'
    document.title = translated || metaTitle || 'CartSee';
  } else {
    document.title = 'CartSee';
  }

})

export default router;
